import * as React from "react"

import { cn } from "../../lib/utils"

function Card({
  className,
  size = "default",
  ...props
}: React.ComponentProps<"div"> & { size?: "default" | "sm" }) {
  return (
    <div
      data-slot="card"
      data-size={size}
      className={cn("cn-card group/card", className)}
      {...props}
    />
  )
}

function CardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-header"
      className={cn("cn-card-header group/card-header", className)}
      {...props}
    />
  )
}

type CardTitleTag = "div" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6"

function CardTitle({
  className,
  tag,
  as,
  ...props
}: Omit<React.ComponentProps<"div">, "tag"> & {
  tag?: CardTitleTag
  as?: CardTitleTag
}) {
  // Phase 5703 (v64.2): accept `tag` (Cogo JSON convention) or `as` (Radix convention).
  // Defaults to "div" when neither is set — preserves existing behavior.
  const Tag = (tag ?? as ?? "div") as React.ElementType
  return (
    <Tag
      data-slot="card-title"
      className={cn("cn-card-title cn-font-heading", className)}
      {...props}
    />
  )
}

function CardDescription({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-description"
      className={cn("cn-card-description", className)}
      {...props}
    />
  )
}

function CardAction({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-action"
      className={cn("cn-card-action", className)}
      {...props}
    />
  )
}

function CardContent({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-content"
      className={cn("cn-card-content", className)}
      {...props}
    />
  )
}

function CardFooter({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-footer"
      className={cn("cn-card-footer", className)}
      {...props}
    />
  )
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
}
